import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import {
  LOAD_SANTANDER_DOMICILED_COLLECTION_REPORTS,
  loadSantanderDomiciledCollectionReports,
  CLEAR_SANTANDER_DOMICILED_COLLECTION_OPTIONS
} from 'src/store/actions/santanderDomiciledCollectionActions';
import {
  selectSantanderDomiciledCollectionList,
  selectSantanderDomiciledCollectionCount,
  selectSantanderDomiciledCollectionQueryOptions
} from 'src/store/selectors/santanderDomiciledCollectionSelectors';
import momentLocalTimezone from 'src/utils/momentLocalTimezone';
import DomiciledCollectionReportsTable from './DomiciledCollectionReportsTable';

const DomiciledCollectionReportsList = () => {
  const dispatch = useDispatch();
  const reports = useSelector(selectSantanderDomiciledCollectionList);
  const count = useSelector(selectSantanderDomiciledCollectionCount);
  const success = useSelector(
    successSelector([LOAD_SANTANDER_DOMICILED_COLLECTION_REPORTS.action])
  );
  const queryOptions = useSelector(
    selectSantanderDomiciledCollectionQueryOptions
  );
  const isLoading = useSelector(
    isLoadingSelector([LOAD_SANTANDER_DOMICILED_COLLECTION_REPORTS.action])
  );

  const handleChangePage = useCallback(
    (event, newPage) => {
      dispatch(
        loadSantanderDomiciledCollectionReports({
          ...queryOptions,
          page: newPage
        })
      );
    },
    [dispatch, queryOptions]
  );

  useEffect(() => {
    const now = momentLocalTimezone();
    const monday = now
      .clone()
      .isoWeekday(1)
      .startOf('day');
    const sunday = now
      .clone()
      .isoWeekday(7)
      .endOf('day');

    const optionsToUse = {
      ...queryOptions,
      startDate: monday.toDate(),
      endDate: sunday.toDate(),
      page: 0
    };

    dispatch(loadSantanderDomiciledCollectionReports(optionsToUse));
    return () => {
      dispatch({ type: CLEAR_SANTANDER_DOMICILED_COLLECTION_OPTIONS });
    };
  }, [dispatch]);

  return (
    <DomiciledCollectionReportsTable
      reports={reports}
      count={count}
      page={queryOptions.page}
      handleChangePage={handleChangePage}
      loading={isLoading}
      success={success}
    />
  );
};

export default DomiciledCollectionReportsList;
